var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 571,
    height: 371,
    viewBox: "0 0 571 371",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 567,
    height: 371
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 567,
    height: 371,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1056.18 367.51H0V370H1056.18V367.51Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.14 230.327H113.03V365.428H116.02V227.828H47.14V365.428H50.14V230.327Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 344.64H102.05V351.711H105.04V344.64Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 344.64H93.06V351.711H96.05V344.64Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 344.64H84.08V351.711H87.08V344.64Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 344.64H66.11V351.711H69.11V344.64Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 344.64H57.13V351.711H60.13V344.64Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 333.839H93.06V340.909H96.05V333.839Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 333.839H84.08V340.909H87.08V333.839Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 333.839H75.09V340.909H78.09V333.839Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 333.839H66.11V340.909H69.11V333.839Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 333.839H57.13V340.909H60.13V333.839Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 323.029H102.05V330.099H105.04V323.029Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 323.029H93.06V330.099H96.05V323.029Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 323.029H84.08V330.099H87.08V323.029Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 323.029H75.09V330.099H78.09V323.029Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 312.219H102.05V319.289H105.04V312.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 312.219H93.06V319.289H96.05V312.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 312.219H84.08V319.289H87.08V312.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 312.219H75.09V319.289H78.09V312.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 312.219H66.11V319.289H69.11V312.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 312.219H57.13V319.289H60.13V312.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 301.408H102.05V308.479H105.04V301.408Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 301.408H93.06V308.479H96.05V301.408Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 301.408H84.08V308.479H87.08V301.408Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 301.408H75.09V308.479H78.09V301.408Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 301.408H66.11V308.479H69.11V301.408Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 301.408H57.13V308.479H60.13V301.408Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 290.598H102.05V297.669H105.04V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 290.598H84.08V297.669H87.08V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 290.598H75.09V297.669H78.09V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 290.598H66.11V297.669H69.11V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 279.797H102.05V286.867H105.04V279.797Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 279.797H93.06V286.867H96.05V279.797Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 279.797H84.08V286.867H87.08V279.797Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 279.797H75.09V286.867H78.09V279.797Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 279.797H66.11V286.867H69.11V279.797Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 268.986H102.05V276.057H105.04V268.986Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 268.986H93.06V276.057H96.05V268.986Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 268.986H84.08V276.057H87.08V268.986Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 268.986H75.09V276.057H78.09V268.986Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 268.986H66.11V276.057H69.11V268.986Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 268.986H57.13V276.057H60.13V268.986Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 258.176H102.05V265.247H105.04V258.176Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 258.176H93.06V265.247H96.05V258.176Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 258.176H84.08V265.247H87.08V258.176Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 258.176H75.09V265.247H78.09V258.176Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 258.176H57.13V265.247H60.13V258.176Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 247.366H102.05V254.437H105.04V247.366Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.08 247.366H84.08V254.437H87.08V247.366Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 247.366H75.09V254.437H78.09V247.366Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 247.366H66.11V254.437H69.11V247.366Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 247.366H57.13V254.437H60.13V247.366Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.04 236.565H102.05V243.635H105.04V236.565Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05 236.565H93.06V243.635H96.05V236.565Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09 236.565H75.09V243.635H78.09V236.565Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.11 236.565H66.11V243.635H69.11V236.565Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13 236.565H57.13V243.635H60.13V236.565Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.03 223.814H116.02V175.826L177.52 155.339V179.191V306.955H180.51V179.191V151.658V143.663L186.9 137.999V306.672H189.9V135.351V123.6V115.596H199.55V278.547H202.54V113.098H186.9V123.6V134.36L177.52 142.672V152.657L113.03 174.136V223.814Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.75 338.128V335.638H122.35V345.057H147.42V342.567H125.34V338.128H147.75Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.75 323.995V321.505H122.35V330.924H147.42V328.434H125.34V323.995H147.75Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.43 309.862V307.371H122.35V316.791H147.42V314.301H125.34V309.862H168.43Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 302.658H169.93V293.238H122.35V302.658ZM125.34 295.729H166.94V300.159H125.34V295.729Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 288.525H169.93V279.105H122.35V288.525ZM125.34 281.595H166.94V286.026H125.34V281.595Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 274.391H169.93V264.972H122.35V274.391ZM125.34 267.462H166.94V271.893H125.34V267.462Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 260.258H169.93V250.839H122.35V260.258ZM125.34 253.329H166.94V257.76H125.34V253.329Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 246.125H169.93V236.706H122.35V246.125ZM125.34 239.196H166.94V243.627H125.34V239.196Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 231.992H169.93V222.573H122.35V231.992ZM125.34 225.063H166.94V229.494H125.34V225.063Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 217.851H169.93V208.432H122.35V217.851ZM125.34 210.93H166.94V215.361H125.34V210.93Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35 203.718H169.93V194.299H122.35V203.718ZM125.34 196.797H166.94V201.228H125.34V196.797Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.93 180.165H122.35V189.585H169.93V180.165ZM166.94 187.095H125.34V182.664H166.94V187.095Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.19 365.428V292.889H261.27V282.562H199.55V306.955H202.54V285.06H258.28V295.379H306.2V365.428H309.19Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 351.919H258.78V354.418H301.21V351.919Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 346.098H258.78V348.588H301.21V346.098Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 340.276H258.78V342.775H301.21V340.276Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 334.455H258.78V336.953H301.21V334.455Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 328.642H258.78V331.132H301.21V328.642Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 322.82H258.78V325.311H301.21V322.82Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 316.999H258.78V319.497H301.21V316.999Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 311.177H258.78V313.668H301.21V311.177Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 305.356H258.78V307.846H301.21V305.356Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21 299.543H258.78V302.041H301.21V299.543Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.03 348.796H250.04V354.41H253.03V348.796Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05 348.796H244.05V354.41H247.05V348.796Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 348.796H238.06V354.41H241.05V348.796Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07 348.796H232.07V354.41H235.07V348.796Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08 348.796H226.08V354.41H229.08V348.796Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1 348.796H214.1V354.41H217.1V348.796Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11 348.796H208.11V354.41H211.11V348.796Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05 340.485H244.05V346.098H247.05V340.485Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 340.485H238.06V346.098H241.05V340.485Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07 340.485H232.07V346.098H235.07V340.485Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08 340.485H220.09V346.098H223.08V340.485Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1 340.485H214.1V346.098H217.1V340.485Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11 340.485H208.11V346.098H211.11V340.485Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.03 332.173H250.04V337.786H253.03V332.173Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05 332.173H244.05V337.786H247.05V332.173Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 332.173H238.06V337.786H241.05V332.173Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07 332.173H232.07V337.786H235.07V332.173Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08 332.173H226.08V337.786H229.08V332.173Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1 332.173H214.1V337.786H217.1V332.173Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11 332.173H208.11V337.786H211.11V332.173Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.03 323.861H250.04V329.475H253.03V323.861Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05 323.861H244.05V329.475H247.05V323.861Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 323.861H238.06V329.475H241.05V323.861Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08 323.861H226.08V329.475H229.08V323.861Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08 323.861H220.09V329.475H223.08V323.861Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1 323.861H214.1V329.475H217.1V323.861Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.03 315.541H250.04V321.155H253.03V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05 315.541H244.05V321.155H247.05V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 315.541H238.06V321.155H241.05V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07 315.541H232.07V321.155H235.07V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08 315.541H226.08V321.155H229.08V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08 315.541H220.09V321.155H223.08V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1 315.541H214.1V321.155H217.1V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11 315.541H208.11V321.155H211.11V315.541Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.03 307.23H250.04V312.843H253.03V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05 307.23H244.05V312.843H247.05V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 307.23H238.06V312.843H241.05V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07 307.23H232.07V312.843H235.07V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08 307.23H226.08V312.843H229.08V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08 307.23H220.09V312.843H223.08V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1 307.23H214.1V312.843H217.1V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11 307.23H208.11V312.843H211.11V307.23Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.03 298.918H250.04V304.531H253.03V298.918Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05 298.918H244.05V304.531H247.05V298.918Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 298.918H238.06V304.531H241.05V298.918Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07 298.918H232.07V304.531H235.07V298.918Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08 298.918H226.08V304.531H229.08V298.918Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08 298.918H220.09V304.531H223.08V298.918Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11 298.918H208.11V304.531H211.11V298.918Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.03 290.598H250.04V296.212H253.03V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05 290.598H238.06V296.212H241.05V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08 290.598H226.08V296.212H229.08V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08 290.598H220.09V296.212H223.08V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1 290.598H214.1V296.212H217.1V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11 290.598H208.11V296.212H211.11V290.598Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 166.84L230.03 165.208V278.547H233.02V164.5L240.01 162.851V278.547H243V162.151L249.99 160.502V278.547H252.99V159.803L259.97 158.154V278.547H262.97V157.454L272.75 155.147V186.12H291.72V115.188L321.79 105.061H344.63V114.347V278.406H347.62V114.347V102.571V97.9987H344.63V102.571H321.21L288.73 113.506V183.63H275.75V151.849L220.09 164.95V278.547H223.09V166.84Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 283.952H272.75V286.451H292.22V283.952Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 277.298H272.75V279.788H292.22V277.298Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 270.652H272.75V273.142H292.22V270.652Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 263.998H272.75V266.488H292.22V263.998Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 257.344H272.75V259.842H292.22V257.344Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 250.698H272.75V253.196H292.22V250.698Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 244.043H272.75V246.542H292.22V244.043Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 237.389H272.75V239.887H292.22V237.389Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 230.743H272.75V233.233H292.22V230.743Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 224.089H272.75V226.579H292.22V224.089Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 217.443H272.75V219.941H292.22V217.443Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 210.789H272.75V213.287H292.22V210.789Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 204.134H272.75V206.633H292.22V204.134Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 197.488H272.75V199.978H292.22V197.488Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 190.834H272.75V193.324H292.22V190.834Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.51 365.428V282.562H317.68V365.428H320.67V285.06H410.52V365.428H413.51Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.99 343.291V351.919H403.86V349.421H329.99V343.291H326.99Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.86 336.953H329.99V330.824H326.99V339.444H403.86V336.953Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.86 324.478H329.99V318.348H326.99V326.976H403.86V324.478Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.86 312.01H329.99V305.881H326.99V314.509H403.86V312.01Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.86 299.543H329.99V293.405H326.99V302.033H403.86V299.543Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.65 268.57H299.71V276.049H302.7V271.069H335.65V268.57Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 265.247H302.7V260.258H335.65V257.76H299.71V265.247Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 254.437H302.7V249.448H335.65V246.95H299.71V254.437Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 243.627H302.7V238.638H335.65V236.148H299.71V243.627Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 232.817H302.7V227.828H335.65V225.338H299.71V232.817Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 222.015H302.7V217.026H335.65V214.528H299.71V222.015Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 211.205H302.7V206.216H335.65V203.718H299.71V211.205Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 200.395H302.7V195.406H335.65V192.916H299.71V200.395Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 189.585H302.7V184.596H335.65V182.106H299.71V189.585Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 178.783H302.7V173.794H335.65V171.296H299.71V178.783Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 167.973H302.7V162.984H335.65V160.486H299.71V167.973Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 157.163H302.7V152.174H335.65V149.684H299.71V157.163Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 146.353H302.7V141.364H335.65V138.874H299.71V146.353Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.71 135.551H302.7V130.562H335.65V128.064H299.71V135.551Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.65 119.752V117.254H299.71V124.741H302.7V119.752H335.65Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68 278.547H367.67V176.909H463.42V301.617H466.42V174.411H364.68V278.547Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.26 348.663H422.33V351.153H430.26V348.663Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.26 341.176H422.33V343.666H431.26V341.176Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.26 333.697H422.33V336.187H431.26V333.697Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.76 318.731H422.33V321.221H430.76V318.731Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.26 311.244H422.33V313.734H431.26V311.244Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 296.286H422.33V298.777H454.27V296.286Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 288.799H422.33V291.29H454.27V288.799Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 281.321H422.33V283.811H454.27V281.321Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 273.833H375.74V276.332H454.27V273.833Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 266.355H375.74V268.845H454.27V266.355Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 251.389H375.74V253.887H454.27V251.389Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 243.902H375.74V246.392H454.27V243.902Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 236.423H375.74V238.913H454.27V236.423Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 228.936H375.74V231.434H454.27V228.936Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 213.978H375.74V216.468H454.27V213.978Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 206.491H375.74V208.981H454.27V206.491Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 199.012H375.74V201.511H454.27V199.012Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.27 184.046H375.74V186.537H454.27V184.046Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.05 133.161L454.66 115.596H489.38V62.3871H519.33V85.7978H522.32V59.8886H486.39V113.098H453.88L414.05 131.695V172.545H417.05V133.161Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 339.843H509.35V350.67H512.35V339.843Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 339.843H500.36V350.67H503.35V339.843Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 326.043H509.35V336.87H512.35V326.043Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 326.043H500.36V336.87H503.35V326.043Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 312.235H509.35V323.062H512.35V312.235Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 312.235H500.36V323.062H503.35V312.235Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 298.435H509.35V309.262H512.35V298.435Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 298.435H500.36V309.262H503.35V298.435Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 298.435H491.38V309.262H494.37V298.435Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 284.635H509.35V295.462H512.35V284.635Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 284.635H500.36V295.462H503.35V284.635Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 284.635H491.38V295.462H494.37V284.635Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 284.635H482.39V295.462H485.38V284.635Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 284.635H473.41V295.462H476.41V284.635Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 270.827H509.35V281.654H512.35V270.827Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 270.827H500.36V281.654H503.35V270.827Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 270.827H491.38V281.654H494.37V270.827Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 270.827H482.39V281.654H485.38V270.827Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 270.827H473.41V281.654H476.41V270.827Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 257.027H509.35V267.854H512.35V257.027Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 257.027H500.36V267.854H503.35V257.027Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 257.027H491.38V267.854H494.37V257.027Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 257.027H482.39V267.854H485.38V257.027Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 257.027H473.41V267.854H476.41V257.027Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 243.219H509.35V254.046H512.35V243.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 243.219H500.36V254.046H503.35V243.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 243.219H491.38V254.046H494.37V243.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 243.219H482.39V254.046H485.38V243.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 243.219H473.41V254.046H476.41V243.219Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 229.419H509.35V240.246H512.35V229.419Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 229.419H500.36V240.246H503.35V229.419Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 229.419H491.38V240.246H494.37V229.419Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 229.419H482.39V240.246H485.38V229.419Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 229.419H473.41V240.246H476.41V229.419Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 215.619H509.35V226.446H512.35V215.619Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 215.619H500.36V226.446H503.35V215.619Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 215.619H491.38V226.446H494.37V215.619Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 215.619H482.39V226.446H485.38V215.619Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 215.619H473.41V226.446H476.41V215.619Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 201.811H509.35V212.637H512.35V201.811Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 201.811H500.36V212.637H503.35V201.811Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 201.811H491.38V212.637H494.37V201.811Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 201.811H482.39V212.637H485.38V201.811Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 201.811H473.41V212.637H476.41V201.811Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 188.011H509.35V198.837H512.35V188.011Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 188.011H500.36V198.837H503.35V188.011Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 188.011H491.38V198.837H494.37V188.011Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 188.011H482.39V198.837H485.38V188.011Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 188.011H473.41V198.837H476.41V188.011Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.35 174.211H509.35V185.037H512.35V174.211Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.35 174.211H500.36V185.037H503.35V174.211Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.37 174.211H491.38V185.037H494.37V174.211Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.38 174.211H482.39V185.037H485.38V174.211Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41 174.211H473.41V185.037H476.41V174.211Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.58 365.428V93.1434H500.36V163.559H503.36V95.6418H519.33V365.428H522.32V95.6418H563.59V365.428H566.58Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.07 345.681H530.06V341.734H556.51V339.235H527.07V345.681Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 329.258H527.07V335.704H530.06V331.757H556.51V329.258Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 319.289H527.07V325.727H530.06V321.779H556.51V319.289Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 309.312H527.07V315.75H530.06V311.802H556.51V309.312Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 299.335H527.07V305.772H530.06V301.825H556.51V299.335Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 289.357H527.07V295.795H530.06V291.848H556.51V289.357Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 279.38H527.07V285.818H530.06V281.87H556.51V279.38Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 269.403H527.07V275.849H530.06V271.893H556.51V269.403Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 259.426H527.07V265.872H530.06V261.916H556.51V259.426Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 249.448H527.07V255.894H530.06V251.938H556.51V249.448Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 239.471H527.07V245.917H530.06V241.97H556.51V239.471Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 229.494H527.07V235.94H530.06V231.992H556.51V229.494Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 219.517H527.07V225.963H530.06V222.015H556.51V219.517Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 209.539H527.07V215.985H530.06V212.038H556.51V209.539Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 199.562H527.07V206.008H530.06V202.06H556.51V199.562Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 189.585H527.07V196.031H530.06V192.083H556.51V189.585Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 179.607H527.07V186.054H530.06V182.106H556.51V179.607Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 169.63H527.07V176.076H530.06V172.129H556.51V169.63Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 159.661H527.07V166.099H530.06V162.151H556.51V159.661Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 149.684H527.07V156.122H530.06V152.174H556.51V149.684Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 139.707H527.07V146.144H530.06V142.197H556.51V139.707Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 129.729H527.07V136.167H530.06V132.22H556.51V129.729Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 119.752H527.07V126.19H530.06V122.242H556.51V119.752Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 109.775H527.07V116.221H530.06V112.265H556.51V109.775Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.51 99.7976H527.07V106.244H530.06V102.288H556.51V99.7976Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.58 365.761V350.703C484.85 350.062 492.16 343.591 492.16 335.704C492.16 331.54 490.12 327.626 486.52 324.786C488.44 322.596 489.49 319.955 489.49 317.232C489.49 310.153 482.58 304.398 474.08 304.398C466.49 304.398 460.18 308.995 458.91 315.025C456.59 313.459 453.65 312.518 450.44 312.518C443.01 312.518 436.97 317.549 436.97 323.736C436.97 326.068 437.84 328.325 439.46 330.216C436.4 332.681 434.67 336.054 434.67 339.635C434.67 346.456 440.95 352.078 448.94 352.71V365.503H451.94V352.71C456.44 352.352 460.38 350.412 462.98 347.572C465.75 349.371 469.06 350.454 472.58 350.695V365.744H475.58V365.761ZM451.95 350.212V345.756L458.27 340.493L456.15 338.727L451.95 342.225V335.446H448.95V337.703L444.21 333.747L442.09 335.513L448.95 341.226V350.204C442.61 349.587 437.67 345.09 437.67 339.643C437.67 336.404 439.41 333.381 442.46 331.349L443.69 330.524L442.64 329.541C440.92 327.934 439.97 325.877 439.97 323.745C439.97 318.931 444.67 315.017 450.45 315.017C456.23 315.017 460.93 318.931 460.93 323.745C460.93 325.877 459.98 327.942 458.26 329.541L457.21 330.524L458.44 331.349C461.48 333.381 463.23 336.412 463.23 339.643C463.23 345.09 458.29 349.587 451.95 350.212ZM464.57 345.465C465.62 343.708 466.22 341.742 466.22 339.652C466.22 336.071 464.49 332.698 461.43 330.233C463.04 328.342 463.92 326.085 463.92 323.753C463.92 321.471 463.09 319.339 461.68 317.565C461.68 317.457 461.67 317.349 461.67 317.24C461.67 311.536 467.24 306.897 474.09 306.897C480.94 306.897 486.51 311.536 486.51 317.24C486.51 319.772 485.39 322.212 483.35 324.111L482.3 325.094L483.53 325.918C487.12 328.325 489.18 331.89 489.18 335.713C489.18 342.217 483.21 347.589 475.59 348.213V342.725L483 336.554L480.88 334.788L475.59 339.194V330.832H472.59V333.939L466.66 329L464.54 330.766L472.58 337.461V348.213C469.63 347.972 466.87 347.022 464.57 345.465Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.89 317.24H483.89C483.89 315.933 483.51 314.625 482.78 313.468L480.13 314.625C480.63 315.433 480.89 316.316 480.89 317.24Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.55 311.111C478.76 309.803 476.46 309.079 474.08 309.079V311.569C475.73 311.569 477.33 312.069 478.57 312.976L480.55 311.111Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.11 320.422L455.46 321.579C455.88 322.254 456.1 322.987 456.1 323.753H459.1C459.09 322.596 458.76 321.446 458.11 320.422Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.45 316.549V319.039C451.82 319.039 453.14 319.456 454.18 320.214L456.16 318.34C454.58 317.182 452.55 316.549 450.45 316.549Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.32 365.878V352.286C197.77 351.653 204.41 345.731 204.41 338.528C204.41 334.738 202.57 331.182 199.32 328.575C201.04 326.576 201.98 324.186 201.98 321.713C201.98 315.208 195.63 309.92 187.82 309.92C180.92 309.92 175.17 314.051 173.92 319.506C171.82 318.14 169.18 317.315 166.31 317.315C159.48 317.315 153.91 321.946 153.91 327.642C153.91 329.758 154.69 331.807 156.13 333.522C153.37 335.787 151.81 338.852 151.81 342.109C151.81 348.338 157.51 353.485 164.8 354.11V365.644H167.8V354.11C171.84 353.76 175.38 352.028 177.74 349.487C180.23 351.078 183.17 352.044 186.31 352.277V365.869H189.32V365.878ZM167.81 351.595V347.714L173.52 342.958L171.4 341.193L167.81 344.182V338.286H164.81V340.068L160.72 336.662L158.6 338.428L164.81 343.599V351.595C159.18 350.978 154.81 346.964 154.81 342.117C154.81 339.202 156.38 336.487 159.12 334.655L160.35 333.83L159.3 332.848C157.76 331.407 156.91 329.558 156.91 327.642C156.91 323.328 161.13 319.814 166.31 319.814C171.49 319.814 175.71 323.328 175.71 327.642C175.71 329.558 174.86 331.407 173.32 332.848L172.27 333.83L173.5 334.655C176.24 336.487 177.81 339.21 177.81 342.117C177.81 346.964 173.44 350.978 167.81 351.595ZM179.33 347.372C180.26 345.781 180.8 343.999 180.8 342.117C180.8 338.861 179.24 335.796 176.48 333.531C177.92 331.807 178.7 329.758 178.7 327.651C178.7 325.56 177.95 323.612 176.66 321.988C176.66 321.896 176.65 321.813 176.65 321.721C176.65 316.591 181.66 312.427 187.81 312.427C193.97 312.427 198.98 316.599 198.98 321.721C198.98 323.995 197.97 326.193 196.14 327.901L195.09 328.883L196.32 329.708C199.56 331.873 201.41 335.088 201.41 338.536C201.41 344.357 196.11 349.163 189.31 349.787V344.965L196.01 339.385L193.89 337.62L189.3 341.442V334.097H186.3V336.654L181.14 332.356L179.02 334.122L186.3 340.185V349.796C183.75 349.546 181.35 348.713 179.33 347.372Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.88 321.713H196.87C196.87 320.497 196.52 319.298 195.84 318.223L193.19 319.381C193.65 320.114 193.88 320.897 193.88 321.713Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.79 316.058C192.14 314.85 190.02 314.176 187.82 314.176V316.674C189.29 316.674 190.71 317.124 191.82 317.932L193.79 316.058Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41 324.561L170.76 325.719C171.14 326.318 171.33 326.968 171.33 327.642H174.33C174.31 326.568 174 325.502 173.41 324.561Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31 320.98V323.478C167.53 323.478 168.7 323.845 169.61 324.519L171.59 322.645C170.13 321.571 168.26 320.98 166.31 320.98Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.7 77.3696C327.31 77.3696 322.83 80.7092 322.1 85.0399H316.04C315.21 85.0399 314.54 85.5979 314.54 86.2892C314.54 86.9804 315.21 87.5384 316.04 87.5384H323.49C324.32 87.5384 324.99 86.9804 324.99 86.2892C324.99 82.7497 328.45 79.8681 332.7 79.8681C334.53 79.8681 336.3 80.4094 337.68 81.3922C338.31 81.8336 339.25 81.7753 339.79 81.2506C340.33 80.7259 340.25 79.9347 339.62 79.4933C338.68 78.8271 337.61 78.3107 336.47 77.9526C338.47 72.0812 344.99 67.917 352.42 67.917C359.1 67.917 365.1 71.2317 367.7 76.3536C368.02 76.9865 368.9 77.2863 369.66 77.0198C370.42 76.7533 370.78 76.0204 370.45 75.3875C370.12 74.7379 369.74 74.1216 369.32 73.5219C369.89 73.4553 370.46 73.4137 371.04 73.4137C377.43 73.4137 382.63 77.7444 382.63 83.0661C382.63 83.7574 383.3 84.3154 384.13 84.3154C384.96 84.3154 385.63 83.7574 385.63 83.0661C385.63 82.5248 385.57 82.0001 385.49 81.4754C389.09 81.4921 392.01 83.9323 392.01 86.9388C392.01 87.63 392.68 88.188 393.51 88.188H400.85C401.68 88.188 402.35 87.63 402.35 86.9388C402.35 86.2475 401.68 85.6895 400.85 85.6895H394.89C394.17 81.8919 390.21 78.9853 385.46 78.9853C385.23 78.9853 385 79.002 384.78 79.0103C382.77 74.3048 377.38 70.9235 371.05 70.9235C369.84 70.9235 368.64 71.0568 367.47 71.2983C363.81 67.6339 358.34 65.4269 352.42 65.4269C343.59 65.4269 335.86 70.4072 333.55 77.4113C333.27 77.3779 332.99 77.3696 332.7 77.3696Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.26 40.0923H236.73C237.56 40.0923 238.23 39.5343 238.23 38.843C238.23 34.1542 242.81 30.3482 248.43 30.3482C250.85 30.3482 253.19 31.0644 255.03 32.3636C255.66 32.8134 256.61 32.7467 257.14 32.2221C257.68 31.6974 257.6 30.9062 256.97 30.4648C255.72 29.582 254.28 28.9074 252.75 28.466C255.22 20.6957 263.75 15.1491 273.51 15.1491C282.17 15.1491 289.94 19.4382 293.31 26.0758C293.63 26.7088 294.51 27.0086 295.27 26.7421C296.03 26.4756 296.39 25.7427 296.07 25.1097C295.58 24.152 295.01 23.2359 294.37 22.3614C295.3 22.2198 296.24 22.1365 297.19 22.1365C305.54 22.1365 312.32 27.7914 312.32 34.7372C312.32 35.4285 312.99 35.9864 313.82 35.9864C314.65 35.9864 315.32 35.4285 315.32 34.7372C315.32 33.9377 315.22 33.1632 315.08 32.397C315.22 32.3886 315.37 32.3803 315.51 32.3803C320.33 32.3803 324.25 35.645 324.25 39.6592C324.25 40.3505 324.92 40.9085 325.75 40.9085H335.08C335.91 40.9085 336.58 40.3505 336.58 39.6592C336.58 38.968 335.91 38.41 335.08 38.41H327.15C326.41 33.6046 321.47 29.8818 315.51 29.8818C315.13 29.8818 314.74 29.8985 314.36 29.9318C311.94 23.9604 305.17 19.6381 297.19 19.6381C295.59 19.6381 294.02 19.8213 292.49 20.1627C287.92 15.4822 281.01 12.6506 273.51 12.6506C262.35 12.6506 252.6 19.0134 249.83 27.9164C249.37 27.8747 248.9 27.8497 248.43 27.8497C241.66 27.8497 236.06 32.1221 235.32 37.5938H227.26C226.43 37.5938 225.76 38.1518 225.76 38.843C225.76 39.5343 226.43 40.0923 227.26 40.0923Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43 135.259H84.71C85.54 135.259 86.21 134.701 86.21 134.01C86.21 130.571 89.57 127.772 93.7 127.772C95.47 127.772 97.2 128.297 98.55 129.255C99.18 129.704 100.13 129.638 100.66 129.113C101.2 128.588 101.12 127.797 100.49 127.356C99.58 126.706 98.54 126.207 97.44 125.857C99.4 120.144 105.74 116.096 112.98 116.096C119.49 116.096 125.34 119.327 127.88 124.316C128.2 124.949 129.08 125.249 129.84 124.982C130.6 124.716 130.96 123.983 130.63 123.35C130.32 122.725 129.95 122.134 129.55 121.568C130.09 121.501 130.63 121.468 131.17 121.468C137.39 121.468 142.45 125.682 142.45 130.862C142.45 131.553 143.12 132.111 143.95 132.111C144.78 132.111 145.45 131.553 145.45 130.862C145.45 130.346 145.4 129.838 145.32 129.338C148.8 129.371 151.62 131.737 151.62 134.643C151.62 135.334 152.29 135.892 153.12 135.892H160.29C161.12 135.892 161.79 135.334 161.79 134.643C161.79 133.952 161.12 133.394 160.29 133.394H154.5C153.78 129.688 149.91 126.84 145.25 126.84C145.04 126.84 144.82 126.856 144.61 126.865C142.63 122.267 137.37 118.969 131.18 118.969C130 118.969 128.83 119.094 127.7 119.336C124.12 115.763 118.77 113.606 112.98 113.606C104.35 113.606 96.79 118.47 94.52 125.315C94.25 125.299 93.98 125.282 93.71 125.282C88.43 125.282 84.06 128.539 83.33 132.769H77.44C76.61 132.769 75.94 133.327 75.94 134.019C75.93 134.701 76.6 135.259 77.43 135.259Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.03 29.0074H538.1C538.93 29.0074 539.6 28.4494 539.6 27.7581C539.6 22.7362 544.51 18.647 550.54 18.647C553.13 18.647 555.64 19.4132 557.62 20.804C558.25 21.2454 559.19 21.1871 559.73 20.6624C560.27 20.1378 560.19 19.3466 559.56 18.9052C558.22 17.9558 556.67 17.2395 555.02 16.7731C557.62 8.44486 566.75 2.49015 577.2 2.49015C586.44 2.49015 594.73 7.0707 598.33 14.1581C598.65 14.791 599.53 15.0908 600.29 14.8243C601.05 14.5578 601.41 13.8249 601.09 13.192C600.56 12.1343 599.92 11.1349 599.21 10.1855C600.25 10.0189 601.3 9.91897 602.37 9.91897C611.29 9.91897 618.55 15.9653 618.55 23.3941C618.55 24.0854 619.22 24.6434 620.05 24.6434C620.88 24.6434 621.55 24.0854 621.55 23.3941C621.55 22.5196 621.44 21.6702 621.28 20.829C621.47 20.8207 621.66 20.804 621.84 20.804C627.02 20.804 631.23 24.3102 631.23 28.6243C631.23 29.3155 631.9 29.8735 632.73 29.8735H642.65C643.48 29.8735 644.15 29.3155 644.15 28.6243C644.15 27.933 643.48 27.375 642.65 27.375H634.14C633.4 22.2781 628.17 18.3139 621.85 18.3139C621.42 18.3139 620.99 18.3305 620.57 18.3722C618.03 12.026 610.84 7.42881 602.38 7.42881C600.67 7.42881 598.98 7.62869 597.34 7.99514C592.5 3.01483 585.16 0 577.2 0C565.36 0 555.01 6.77088 552.1 16.2401C551.59 16.1902 551.07 16.1568 550.54 16.1568C543.36 16.1568 537.43 20.7041 536.69 26.5172H528.04C527.21 26.5172 526.54 27.0752 526.54 27.7665C526.53 28.4494 527.2 29.0074 528.03 29.0074Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.28 168.106L454.64 154.19H489.55V151.691H453.91L422.28 165.299V168.106Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.55 160.919H453.91L436.09 168.589V171.396L454.64 163.417H489.55V160.919Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.55 125.99V123.492H453.91L422.28 137.1V139.907L454.64 125.99H489.55Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.28 149.609L454.64 135.692H489.55V133.194H453.91L422.28 146.802V149.609Z",
    fill: "#00C194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.28 158.404L454.64 144.487H489.55V141.989H453.91L422.28 155.597V158.404Z",
    fill: "#00C194"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg-2.1af5dc42fb5a5dc5e8cc9d45d9ca3dd5.svg";
export { ForwardRef as ReactComponent };